import React from "react"
import {graphql, Link} from "gatsby"
import {MDXRenderer} from "gatsby-plugin-mdx"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import {rhythm, scale} from "../utils/typography"

import {MDXProvider} from "@mdx-js/react"
import BarChart from '../components/histogram_cities_weather';
import LineChart from '../components/line_chart_cities_weather';
import CompareCities from '../components/cities_comparision_T';
import {DiscussionEmbed} from "disqus-react"
import ClockCountAgingDeath from "../components/clock_count_aging_death";
import LineChartCauseOfDeath from "../components/line_chart_cause_of_deaths";

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.mdx;
    const siteTitle = this.props.data.site.siteMetadata.title;
    const {previous, next, slug} = this.props.pageContext;

    const shortcodes = {
      BarChart, LineChart, CompareCities, ClockCountAgingDeath, LineChartCauseOfDeath,
    };
    const disqusConfig = {
      shortname: process.env.GATSBY_DISQUS_NAME,
      config: {identifier: slug},
    }
    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <h1 style={{fontWeight: 400}}>{post.frontmatter.title}</h1>
        <p
          style={{
            ...scale(-1 / 5),
            display: `block`,
            marginBottom: rhythm(1),
            marginTop: rhythm(1),
          }}
        >
          {post.frontmatter.date}
        </p>

        <MDXProvider components={shortcodes}>
          <MDXRenderer>{post.body}</MDXRenderer>
        </MDXProvider>

        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />
        <Bio/>
        <hr
          style={{
            marginBottom: rhythm(1),
          }}
        />

        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={`/blog${previous.fields.slug}`} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={`blog${next.fields.slug}`} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>

        <DiscussionEmbed {...disqusConfig} />
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`;
